import Config from "../../config/index";

const initialState = {
    isLoggedIn: false,
    id: null,
    guid: null,
    userName: '',
    userId: '',
    firstName: null,
    lastName: null,
    loading: false,
    submitting: false,
    ssoGetTokenLoading: false,
    ssoGetTokenFailed: false,
    ssoToken: '',
    ssoFailedCounter: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            if (Config.getUser()) {
                return {
                    ...state,
                    ...Config.getUser(),
                    isLoggedIn: true,
                    submitting: false,
                    loading: false,
                };
            }

            return {
                ...state
            };
        case 'USER_RESET':
            return initialState;
        case 'USER_LOGIN_SUBMITTING':
            return {
                ...state,
                submitting: true
            };
        case 'USER_LOGIN_SUCCESS':
            return {
                ...state,
                ...action.payload,
                isLoggedIn: true,
                submitting: false,
                loading: false,
            };
        case 'USER_LOGIN_FAILURE':
            return initialState;
        case 'USER_SET_ACTION_KEYWORD':
            return {
                ...state,
                actionSearchKeyword: action.payload
            };
        case 'USER_LOADING':
            return {
                ...state,
                loading: true
            };
        case 'USER_SINGLE_SUCCESS':
            Config.setUser({
                guid: action.payload.guid,
                userId: action.payload.userId,
                userName: action.payload.username,
            });

            return {
                ...state,
                ...action.payload,
                manager: null,
                ongoingActions: null,
                actionGroups: null,
                loading: false,
                manageAs: null,
                managers: null
            };
        case 'USER_SINGLE_FAILURE':
            return {
                ...state,
                manager: null,
                ongoingActions: null,
                actionGroups: null,
                loading: false
            };
        case 'SSO_GET_TOKEN_LOADING':
            return {
                ...state,
                ssoGetTokenLoading: true,
                ssoTest: false,
                ssoGetTokenFailed: false
            };
        case 'SSO_GET_TOKEN_SUCCESS':
            return {
                ...state,
                ssoGetTokenLoading: false,
                ssoToken: action.payload,
                ssoGetTokenFailed: false,
                ssoFailedCounter: 0,
            };

        case 'SSO_GET_TOKEN_FAILURE':
            return {
                ...state,
                ssoGetTokenLoading: false,
                ssoGetTokenFailed: true,
                ssoToken: false,
                ssoFailedCounter: state.ssoFailedCounter + 1,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/user.js